
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/segment",
      function () {
        return require("private-next-pages/destinations/segment.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/segment"])
      });
    }
  